<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16SYbnu/tc-custom/9781615950249.jpg?1733029640996" alt="This image is the cover for the book Different Paths, Stella Crown Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Different Paths, Stella Crown Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"A sprightly tale and a surprising ending, along with Clemens's trademark quirky characters."—<i>Kirkus Reviews</i></b></p><p>When dairy farmer Stella Crown's friend, veterinarian Carla Beaumont, is car-jacked it's just the first of a rash of vicious attacks on local business women. Then three more women—a truck driver, a minister, and a personal trainer—are targeted for vandalism and theft. But the community is shaken to the core when the kind-hearted Dr. Peterson is found murdered in her office.</p><p>Worried that she and her farmhand Lucy might be next in line, Stella makes it her job to find the connection between the victims, get the good Detective Willard to stop the violence, and track down the killer.</p><p>Meanwhile, Stella's boyfriend Nick insists on joining her on the farm. Will he, with his newly diagnosed MS, be able to protect her? Does she even want him to?</p><p>As she investigates, Stella finds much that doesn't seem right in her usually quiet town. Between her suspicions of steroids at the local gym, irate patients at the doctor's office, and Carla's brand-new boyfriend, Stella's not sure where to focus her attentions. But focus she must—or more women will die.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Judy Clemens
      </h2>
      
      <p class="authorDescription body article"><P>Judy Clemens spends her days in rural Ohio, where she writes, spends time with her family, and eats too much chocolate. She is the author of the Grim Reaper and Stella Crown mysteries, and is a past president of Sisters in Crime.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?50d165f1